// extracted by mini-css-extract-plugin
module.exports = {"confirmDialogTitle":"ConfirmDialog_confirmDialogTitle_4NsUl","confirmDialogSubtitle":"ConfirmDialog_confirmDialogSubtitle_3dJJ5"};